module.exports = __webpack_public_path__ + "img/workshop-detail-banner-1200X800.ce3d2dea.png";